import { Provider } from './providers.types';
import BaseProvider from './base-provider';

const SDK = {
  id: 'tagboard-embed-js',
  globalName: 'tagbrd',
  url: 'https://static.tagboard.com/embed/assets/js/embed.js'
};

export default function Tagboard(): Provider {
  const provider = BaseProvider(SDK);

  return {
    mount
  };

  async function mount(element, url) {
    element.classList.remove('social-embed--rendered');

    const tagboardAttributes = element.getAttributeNames()
      .filter(attr => {
        const hasTgbAttr = attr.split('-')[0] === 'tgb';

        if (hasTgbAttr && attr !== 'tgb-embed-id') {
          return true;
        }

        return false;
      })
      .map(attr => `${attr}="${element.getAttribute(attr)}"`)
      .join(' ');


    const contentElement = element.querySelector('[data-content]');

    contentElement.innerHTML = `<div class="tagboard-embed" tgb-embed-id="${url}" ${tagboardAttributes}></div>`;


    await provider.provideSDK();
  }
}
